import * as React from 'react';
import './MembershipTypesPage.scss';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { routerActions } from 'react-router-redux';
import { Location, History } from "history";
import ReactTable, { RowInfo } from 'react-table';
import * as MembershipTypeActions from '../../../actions/membershipTypes';
import * as Dtos from '../../../dtos/Tmd.dtos';
import { ITmdState, IFormFilter } from "../../../reducers/index";
import { RequestState } from "../../../enumerations/RequestState";
import { Link } from "../../../components/routing/index";
import { FontAwesomeIcon, FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import { DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS } from "../../../constants/reactTableConstants";
import * as AuthenticationHelper from '../../../helpers/authentication';
import { FormFilterInput } from '../../../components/form';
import { LookupsLayout } from '../../index';
interface IMembershipTypesPageProps {
  location: Location;
  history: History;

  // From state
  formFilter: IFormFilter;
  membershipType: Dtos.MembershipType[];
  loadingMembershipTypes: boolean;
  loadMembershipTypesSuccess: boolean;
  loadMembershipTypesFailure: boolean;
  user: Dtos.User;
  permissions?: Dtos.PersonnelTmdPermissions[];
  formRoles?: Dtos.RoleType[];
}
interface IMembershipTypesPageActions {
  clearMembershipTypes: MembershipTypeActions.IMembershipTypeClearActionCreator;
  loadMembershipTypes: MembershipTypeActions.IMembershipTypeLoadActionCreator;
  navigate: typeof routerActions.push;
  navigateReplace: typeof routerActions.replace;
  filter: MembershipTypeActions.IMembershipTypeFilterActionCreator;
}
type MembershipTypesPageProps = IMembershipTypesPageProps & IMembershipTypesPageActions;
class MembershipTypesPage extends React.PureComponent<MembershipTypesPageProps, any> {
  constructor(props: MembershipTypesPageProps) {
    super(props);
    this.clearMembershipTypes = this.clearMembershipTypes.bind(this);
  }
  componentDidMount() {
    const {
      loadMembershipTypes
    } = this.props;
    loadMembershipTypes();
  }
  componentWillReceiveProps(nextProps: MembershipTypesPageProps) {}
  componentDidUpdate(prevProps: MembershipTypesPageProps, prevState) {
    const {
      navigateReplace
    } = this.props;
  }
  componentWillUpdate(nextProps: MembershipTypesPageProps) {}
  componentWillUnmount() {
    this.clearMembershipTypes();
  }
  clearMembershipTypes() {
    this.props.clearMembershipTypes();
  }
  showMembershipTypes(): boolean {
    const {
      loadingMembershipTypes,
      loadMembershipTypesSuccess
    } = this.props;
    if (!loadingMembershipTypes && loadMembershipTypesSuccess) {
      return true;
    }
    return false;
  }
  render() {
    const {
      loadingMembershipTypes
    } = this.props;
    return <LookupsLayout loading={loadingMembershipTypes} permission={Dtos.Permission.MembershipTypesView} data-sentry-element="LookupsLayout" data-sentry-component="MembershipTypesPage" data-sentry-source-file="MembershipTypesPage.tsx">
            {this.renderContent()}
        </LookupsLayout>;
  }
  renderContent() {
    const {
      permissions
    } = this.props;
    return <div>
            <div className="row">
                <div className={"col-6 mb-2"}>
                    <h2>Membership Types</h2>
                </div>
                <div className="col-6" style={{
          textAlign: 'right'
        }}>
                    <FormFilterInput formFilter={this.props.formFilter} onFilter={e => this.props.filter(e)} />
                    
                    {AuthenticationHelper.hasPermission(permissions, Dtos.Permission.MembershipTypesCreate) && <Link className={"btn btn-primary"} url={"/settings/general/membershiptypes/create"}>Create</Link>}
                </div>
            </div>
            {!this.showMembershipTypes() ? "Loading Membership Types" : null}
            {this.showMembershipTypes() ? <div className="patient-tables mt-2">
                        {this.createTable()}
                    </div> : null}
        </div>;
  }
  createTable() {
    const {
      membershipType
    } = this.props;
    if (!membershipType || membershipType.length == 0) {
      return <div className="alert alert-info d-flex">
                <div className="mr-2">
                    <FontAwesomeIcon icon={FontAwesomeIcons.Solid.INFO_SQUARE} fixedWidth />
                </div>
                <span>There are currently no membership types to view.</span>
            </div>;
    }
    const showPagination = membershipType.length > DEFAULT_PAGE_SIZE;
    return <div className="table-wrapper mb-3">
            <ReactTable data={membershipType} pageSizeOptions={PAGE_SIZE_OPTIONS} defaultPageSize={showPagination ? DEFAULT_PAGE_SIZE : membershipType.length} pageSize={showPagination ? undefined : membershipType.length} showPagination={showPagination} className="-striped -highlight -clickable mb-3" noDataText="There are currently no membershipType to display" resizable={false} getTdProps={(state, rowInfo: RowInfo, column, instance) => {
        return {
          onClick: (e, handleOriginal) => {
            const url: string = "/settings/general/membershiptypes/" + rowInfo.original.id;
            this.props.navigate(url);
            if (handleOriginal) {
              handleOriginal();
            }
          },
          style: {
            color: rowInfo && rowInfo.original && rowInfo.original.active ? '#212529' : '#9e9e9e'
          }
        };
      }} columns={[{
        id: "id",
        Header: ' ',
        accessor: "id",
        className: "d-flex align-items-center justify-content-center",
        maxWidth: 50,
        Cell: props => <FontAwesomeIcon icon={FontAwesomeIcons.Light.LOOKUP} fixedWidth />
      }, {
        id: "value",
        Header: 'Name',
        accessor: 'value',
        className: "d-flex align-items-left justify-content-left",
        headerClassName: "text-left"
      }]} />
        </div>;
  }
}
const mapStateToProps = (state: ITmdState, ownProps: MembershipTypesPageProps): IMembershipTypesPageProps => {
  let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];
  return {
    history: ownProps.history,
    location: state.routing.location,
    formFilter: state.membershipTypes.formFilter,
    membershipType: state.membershipTypes.formFilteredData,
    loadingMembershipTypes: state.membershipTypes.loadState && state.membershipTypes.loadState.status == RequestState.Pending,
    loadMembershipTypesSuccess: state.membershipTypes.loadState && state.membershipTypes.loadState.status == RequestState.Success,
    loadMembershipTypesFailure: state.membershipTypes.loadState && state.membershipTypes.loadState.status == RequestState.Failure,
    user: state.user.data,
    permissions: permissions,
    formRoles: state.user.formRoles
  };
};
const mapDispatchToProps = (dispatch): IMembershipTypesPageActions => {
  return {
    navigate: bindActionCreators(routerActions.push, dispatch),
    navigateReplace: bindActionCreators(routerActions.replace, dispatch),
    loadMembershipTypes: bindActionCreators(MembershipTypeActions.LoadMembershipType, dispatch),
    clearMembershipTypes: bindActionCreators(MembershipTypeActions.Clear, dispatch),
    filter: bindActionCreators(MembershipTypeActions.Filter, dispatch)
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(MembershipTypesPage);